/** Maps landlord or VP delegation row to sendPropertyRequest accepter payload. */
export function buildRequestAccepter(target) {
  if (!target) return null;

  if (target.sf_landlord_id && !target.accepter_role) {
    return {
      email: target.email_address,
      role: 'll',
      landlordId: target.sf_landlord_id,
      accepterId: target.user_id || null,
    };
  }

  return {
    email: target.accepter_email,
    role: target.accepter_role || 'vp',
    accepterId: target.accepter_id,
  };
}
